module.exports = __webpack_public_path__ + "static/media/Pikachu.786af049.jpg";